import TrainingCoursesMain from './TrainingCoursesMain'
import TrainingCoursesManage from './TrainingCoursesManage'

export default {
  Main: TrainingCoursesMain,
  Manage: TrainingCoursesManage,
}
